import { render, staticRenderFns } from "./Rotation.vue?vue&type=template&id=81e83f98&scoped=true"
import script from "./Rotation.vue?vue&type=script&lang=js"
export * from "./Rotation.vue?vue&type=script&lang=js"
import style0 from "./Rotation.vue?vue&type=style&index=0&id=81e83f98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e83f98",
  null
  
)

export default component.exports